export function getFormattedLanguageName(lang = "en"): string {
  return lang.includes("-") ? lang.split("-")[0] : lang;
}
export function safeParseJson(str: string | null): any {
  try {
    if (typeof str === "string") return JSON.parse(str);
    return str
  } catch {
    return undefined;
  }
}
export function getTranslation(str: string, lang = "en", isInput = false): any {
  const data = safeParseJson(str);

  if (!data) return str;
  lang = getFormattedLanguageName(lang);

  if (data[lang]?.length || isInput) return data[lang];

  for (const lang in data) {
    if (data[lang]) {
      return data[lang];
    }
  }

  return typeof data === "object" ? "" : str;
}
